import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../src/lib/component-base';
import IconHeader from '../../../../../../shared/components/IconHeader/IconHeader';
import departureIcon from '../../../../../../static/images/data-export-icons/Departures-Icons-WHITE.svg';
import arrivalIcon from '../../../../../../static/images/data-export-icons/Arrivals-Icons-WHITE.svg';
import depArrIcon from '../../../../../../static/images/data-export-icons/DepArr-Icon-White.svg';
import routeIcon from '../../../../../../static/images/data-export-icons/Routes-Icon-WHITE.svg';
import Type from './children/Type';

const exportTypesIcons = {
  departing: departureIcon,
  arriving: arrivalIcon,
  deparr: depArrIcon,
  route: routeIcon,
};

@componentBase('Category')
export default class Category extends Component {
  static propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    push: PropTypes.func,
    types: PropTypes.arrayOf(PropTypes.object),
    dispatch: PropTypes.func,
  };

  get types() {
    //
    // TODO: real icons, probabaly cloudfront
    //
    const { push, types } = this.props;
    return types.map((type, index) => {
      const key = `${type}${index}`;

      return (
        <Type
          key={key}
          type={type}
          push={push}
          icon={exportTypesIcons[type.searchTerm]}
          dispatch={this.props.dispatch}
        />
      );
    });
  }

  render = () => (
    <div className='category'>
      <div className='header'>
        <IconHeader title={this.props.title} icon={this.props.icon} />
      </div>
      <div className='row equal'>
        {this.types}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/NewDataExports/children/Category/Category.js